import { makeAutoObservable } from "mobx";

// Global, app-wide operation feedback ("успешно/неуспешно"), independent of
// any one page's own inline messages. Populated by the axios interceptors in
// http/index.ts, so it fires for every mutating API call project-wide
// without each page having to wire it up itself. A plain MobX singleton
// (not React Context) so it's callable from outside the component tree —
// same reasoning as WsStore/UserStore, just not tied to one Context.Provider
// instance since interceptors live entirely outside React.

export type ToastType = 'success' | 'error' | 'info';
export type ToastItem = { id: number, message: string, type: ToastType };

const DEFAULT_DURATION_MS = 4000;

class ToastStore {
    private _items: ToastItem[] = [];
    private _nextId = 1;

    constructor() {
        makeAutoObservable(this);
    }

    get items(): ToastItem[] {
        return this._items;
    }

    push(message: string, type: ToastType = 'info', duration: number = DEFAULT_DURATION_MS) {
        const id = this._nextId++;
        this._items.push({ id, message, type });
        setTimeout(() => this.remove(id), duration);
        return id;
    }

    remove(id: number) {
        this._items = this._items.filter((t) => t.id !== id);
    }
}

// Single shared instance — every caller (interceptors, components) talks to
// the same store, so no Context lookup is needed to reach it.
const toastStore = new ToastStore();
export default toastStore;
